import { SymbolTilesStreamRequest } from 'communication/types/symbolTiles/SymbolTilesStreamRequest';
import {
    IndigoStreamRequest,
    RequestBatchSanitizer,
} from 'communication/streaming/SockJSStreamingService';

/*
 * We only want to send up one request in a batch, as we only have one stream for Symbol Tiles
 */
export const symbolTilesRequestBatchSanitizer: RequestBatchSanitizer = (
    requests: IndigoStreamRequest[]
) => {
    if (requests.length < 1) {
        throw new Error('At least one request expected');
    }
    const retAddSyms: string[] = [];
    const retDelSyms: string[] = [];

    for (const request of requests) {
        const symbolTilesRequest = request.payload as SymbolTilesStreamRequest;
        const added = symbolTilesRequest.addSyms
            ? symbolTilesRequest.addSyms.split('|')
            : '';
        const removed = symbolTilesRequest.delSyms
            ? symbolTilesRequest.delSyms.split('|')
            : '';

        for (const addedSym of added) {
            const iDel = retDelSyms.indexOf(addedSym);
            if (iDel > -1) {
                retDelSyms.splice(iDel, 1);
            } else {
                retAddSyms.push(addedSym);
            }
        }

        for (const removedSym of removed) {
            const iAdd = retAddSyms.indexOf(removedSym);
            if (iAdd > -1) {
                retAddSyms.splice(iAdd, 1);
            } else {
                retDelSyms.push(removedSym);
            }
        }
    }

    if (retAddSyms.length === 0 && retDelSyms.length === 0) {
        return [];
    }

    const payload = {
        addSyms: retAddSyms.join('|'),
        delSyms: retDelSyms.join('|'),
        symbology: requests[0].payload.symbology,
    };

    return [
        {
            indigo2AsyncDestination: requests[0].indigo2AsyncDestination,
            channelId: requests[0].channelId,
            payload,
        },
    ];
};
